
const listaDeFormularios = (state) => {
    console.log('Disparou o getter');
    return state.items || [];
}

const formValues = (state) => {
    return state.formValues || [];
}

const formularioSelecionado = (state) => {
    return state.selecionado
}


const loadingFormularios = (state) => {
    return state.buscando
}

export {
    listaDeFormularios,
    formValues,
    formularioSelecionado,
    loadingFormularios
}